import axios from "axios";

export const ACTION_GET_NEW_CLIENT_PENDING = 'ACTION_GET_NEW_CLIENT_PENDING';
export const ACTION_GET_NEW_CLIENT_SUCCESS = 'ACTION_GET_NEW_CLIENT_SUCCESS';
export const ACTION_GET_NEW_CLIENT_ERROR = 'ACTION_GET_NEW_CLIENT_ERROR';

function fetchNewClientPending() {
    return {
        type: ACTION_GET_NEW_CLIENT_PENDING
    }
}

function fetchNewClientSuccess(newClient) {
    return {
        type: ACTION_GET_NEW_CLIENT_SUCCESS,
        newClient: newClient
    }
}

function fetchNewClientError(error) {
    return {
        type: ACTION_GET_NEW_CLIENT_ERROR,
        error: error
    }
}

function fetchNewClientAction() {
    axios.defaults.baseURL = window.location.origin;
    var url = '/api/Client/New';
    return dispatch => {
        dispatch(fetchNewClientPending());
        axios.post(url, null, { withCredentials: true })
            .then(res => res.data)
            .then(res => {
                dispatch(fetchNewClientSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(fetchNewClientError(error));
            })
    }
}

export default fetchNewClientAction;
